/* Cocoonette — typographie française
   En français, les signes doubles (: ; ? !) et les guillemets prennent une espace
   fine insécable. Avec une espace normale, le navigateur peut couper la ligne
   juste avant le signe — on se retrouve avec un « ; » orphelin en début de ligne.
   Ce script remplace ces espaces par une espace fine insécable (U+202F). */
(function () {
  var NBSP = String.fromCharCode(8239);
  var main = document.getElementById('main');
  if (!main || !document.createTreeWalker) return;

  var skip = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, CODE: 1, PRE: 1, NOSCRIPT: 1, OPTION: 1 };

  var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      if (!node.parentNode || skip[node.parentNode.nodeName]) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }
  });

  var nodes = [];
  var n;
  while ((n = walker.nextNode())) nodes.push(n);

  nodes.forEach(function (t) {
    var s = t.nodeValue;
    if (!s || s.indexOf(' ') === -1) return;
    var out = s.replace(/ +([;:?!%»])/g, NBSP + '$1').replace(/(«) +/g, '$1' + NBSP);
    if (out !== s) t.nodeValue = out;
  });
})();